
      <!--  CHECKBOX  -->

      <ui-checkbox-control
          *ngIf="uiFormControl.type === 'checkbox'"
          [id]="uiFormControl.id"
          [form]="form"
          [name]="uiFormControl.name"
          [text]="uiFormControl.text"
          [isInvalid]="uiFormControl.validators.length && isInvalid"
          [invalidReasons]="invalidReasons"
          (onEvent)="onChildEvent($event)">
      </ui-checkbox-control>

      <!--  END CHECKBOX  -->

      <!--  INPUT  -->

      <ui-input-control
          *ngIf="uiFormControl.type === 'input'"
          [id]="uiFormControl.id"
          [form]="form"
          [name]="uiFormControl.name"
          [placeholder]="uiFormControl.placeholder"
          [inputType]="uiFormControl.inputType"
          [prefixes]="uiFormControl.prefixes"
          [suffixes]="uiFormControl.suffixes"
          [hasValidators]="uiFormControl.validators.length"
          [isInvalid]="isInvalid"
          [invalidReasons]="invalidReasons"
          [showPasswordStrength]="uiFormControl.showPasswordStrength"
          [isDefaultFocus]="uiFormControl.defaultFocus"
          (onEvent)="onChildEvent($event)">
      </ui-input-control>

      <!--  END INPUT  -->

      <!--  TEXTAREA  -->

      <ui-textarea-control
          *ngIf="uiFormControl.type === 'textarea'"
          [id]="uiFormControl.id"
          [form]="form"
          [name]="uiFormControl.name"
          [placeholder]="uiFormControl.placeholder"
          [prefixes]="uiFormControl.prefixes"
          [suffixes]="uiFormControl.suffixes"
          [hasValidators]="uiFormControl.validators.length"
          [isInvalid]="isInvalid"
          [invalidReasons]="invalidReasons"
          [isDefaultFocus]="uiFormControl.defaultFocus"
          [rows]="uiFormControl.rows">
      </ui-textarea-control>

      <!--  END TEXTAREA  -->

      <!--  SLIDER  -->

      <ui-slider-control
          *ngIf="uiFormControl.type === 'range'"
          [id]="uiFormControl.id"
          [form]="form"
          [name]="uiFormControl.name"
          [min]="uiFormControl.min"
          [max]="uiFormControl.max"
          [step]="uiFormControl.step"
          [invert]="uiFormControl.invert"
          [thumbLabel]="uiFormControl.thumbLabel"
          [tickInterval]="uiFormControl.tickInterval"
          [textInput]="uiFormControl.textInput"
          [prefixes]="uiFormControl.prefixes"
          [suffixes]="uiFormControl.suffixes"
          [isDefaultFocus]="uiFormControl.defaultFocus">
      </ui-slider-control>

      <!-- END SLIDER  -->

      <!--  SELECT  -->

      <ui-select-control
          *ngIf="uiFormControl.type === 'select'"
          [id]="uiFormControl.id"
          [form]="form"
          [name]="uiFormControl.name"
          [options]="uiFormControl.options"
          [prefixes]="uiFormControl.prefixes"
          [suffixes]="uiFormControl.suffixes"
          [hasValidators]="uiFormControl.validators.length"
          [isInvalid]="isInvalid"
          [invalidReasons]="invalidReasons"
          (onEvent)="onChildEvent($event)">
      </ui-select-control>

      <!--  END SELECT  -->

      <!--  MULTI  -->

      <ui-multi-control
          *ngIf="uiFormControl.type === 'multi'"
          [form]="form"
          [uiFormControl]="uiFormControl"
          [items]="uiFormControl.items"
          (onEvent)="onChildEvent($event)">
      </ui-multi-control>

      <!--  END MULTI  -->
    